import { gsap } from 'gsap';
import React from 'react';

export const animation = (ref: React.MutableRefObject<undefined>) =>
  gsap.context(() => {
    gsap.from(ref.current, { y: 10 });
    gsap.from(ref.current, { opacity: 0, duration: 0.5 });
    gsap.to(ref.current, {
      y: 10,
      delay: 4.5,
      opacity: 0,
    });
    gsap.to(ref.current, {
      delay: 5,
      display: 'none',
    });
  }, ref);
